// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReviewPhotos-contentWrapper-hSjBo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  padding: 30px 35px 15px;
  overflow-y: auto;
}

.ReviewPhotos-photoGrid-AfRur {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  width: 100%;
}

/* Foto de portada: 2 columnas x 3 filas */

.ReviewPhotos-photoItemCover-V2mVZ {
  grid-column: 1 / 3;
  grid-row: 1 / 4;
  position: relative;
  border-radius: 22px;
  overflow: hidden;
  cursor: -webkit-grab;
  cursor: grab;
  background-color: #f1f5f9;
  min-height: 220px;
  -webkit-box-shadow: 0 4px 14px rgba(15, 76, 129, 0.08);
          box-shadow: 0 4px 14px rgba(15, 76, 129, 0.08);
}

.ReviewPhotos-photoItem-PSOoS {
  position: relative;
  border-radius: 22px;
  overflow: hidden;
  cursor: -webkit-grab;
  cursor: grab;
  background-color: #f1f5f9;
  aspect-ratio: 6 / 5;
  -webkit-box-shadow: 0 4px 14px rgba(15, 76, 129, 0.08);
          box-shadow: 0 4px 14px rgba(15, 76, 129, 0.08);
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

/*
  Fila 3: tres celdas del mismo tamaño en las columnas 2, 3 y 4.
  Las celdas son: foto 6, foto 7 (o tarjeta "Agregar") y la siguiente.
  La celda de la columna 2 se sobrepone a la portada.
*/

.ReviewPhotos-photoGrid-AfRur> :nth-child(6) {
  grid-column: 2;
  grid-row: 3;
  z-index: 2333;
  border-radius: 20px 0px 20px 0px;
  border: 9px solid var(--background-primary);
  position: relative;
  /* Ensure positioning context for the pseudo-element */
  -webkit-box-shadow: 0 0 0 10px var(--background-primary);
          box-shadow: 0 0 0 10px var(--background-primary);
  /* Creates an outward border effect */
}

.ReviewPhotos-photoGrid-AfRur> :nth-child(6)::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 10px;
  top: -10px;
  /* Position the tab above the container */
  left: 30px;
  border-radius: 20px;
  /* Rounded top corners for the tab */
  background-color: var(--background-primary);
  /* Match the border color */
  z-index: 1;
  /* Ensure it appears above other elements */
}

.ReviewPhotos-photoGrid-AfRur> :nth-child(7) {
  grid-column: 3;
  grid-row: 3;
}

.ReviewPhotos-photoGrid-AfRur> :nth-child(8) {
  grid-column: 4;
  grid-row: 3;
}

/* Desde el hijo 9 en adelante, el grid fluye en filas de 4 columnas */

.ReviewPhotos-photoItemCover-V2mVZ:active,
.ReviewPhotos-photoItem-PSOoS:active {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}

.ReviewPhotos-photoThumb-bdan9 {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #e2e8f0;
}

.ReviewPhotos-coverBadge-ij99b {
  position: absolute;
  top: 16px;
  left: 16px;
  background-color: #0b375b;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  z-index: 2;
  letter-spacing: 0.1px;
  -webkit-box-shadow: 0 2px 6px rgba(11, 55, 91, 0.25);
          box-shadow: 0 2px 6px rgba(11, 55, 91, 0.25);
}

.ReviewPhotos-deleteBtn-LHX4g {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background-color: #ffffff;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  z-index: 3;
  padding: 0;
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  -webkit-transition: background-color 0.15s ease, -webkit-transform 0.15s ease;
  transition: background-color 0.15s ease, -webkit-transform 0.15s ease;
  transition: transform 0.15s ease, background-color 0.15s ease;
  transition: transform 0.15s ease, background-color 0.15s ease, -webkit-transform 0.15s ease;
}

.ReviewPhotos-deleteBtn-LHX4g svg {
  width: 13px;
  height: 13px;
}

.ReviewPhotos-deleteBtn-LHX4g:hover {
  -webkit-transform: scale(1.08);
      -ms-transform: scale(1.08);
          transform: scale(1.08);
  background-color: #f8fafc;
}

.ReviewPhotos-addPhotoCard-Ubmne {
  position: relative;
  width: 100%;
  border: 1.8px dashed #b3d4f5;
  background: #f7fbff;
  border-radius: 22px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 6px;
  aspect-ratio: 6 / 5;
  padding: 12px 8px;
  -webkit-transition: border-color 0.2s, background 0.2s, color 0.2s;
  transition: border-color 0.2s, background 0.2s, color 0.2s;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
}

.ReviewPhotos-addPhotoCard-Ubmne:hover {
  background: #eef6fe;
  border-color: #2196F3;
  color: #2196F3;
}

.ReviewPhotos-addPhotoText-y7hiK {
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  text-align: center;
  pointer-events: none;
}

.ReviewPhotos-addPhotoCard-Ubmne:hover .ReviewPhotos-addPhotoText-y7hiK {
  color: #2196F3;
}

.ReviewPhotos-hiddenInput-Yczke {
  display: none !important;
  position: absolute !important;
  width: 0 !important;
  height: 0 !important;
  opacity: 0 !important;
  overflow: hidden !important;
  pointer-events: none !important;
}

.ReviewPhotos-isDragging-p4Lvq {
  opacity: 0.4;
}

.ReviewPhotos-isDragOver-gjtDO {
  outline: 2px dashed #0084f8;
  outline-offset: -2px;
}

.ReviewPhotos-infoSection-TNKJK {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 14px;
  margin-top: 24px;
  margin-bottom: 20px;
  padding: 0 2px;
}

.ReviewPhotos-infoIconWrap-pPMuv {
  -ms-flex-negative: 0;
      flex-shrink: 0;
  margin-top: 2px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.ReviewPhotos-infoTextWrap-siDBY {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.ReviewPhotos-infoTitle-ITgym {
  color: #4a6d88;
  font-size: 13.5px;
  line-height: 1.45;
  margin: 0 0 3px 0;
  font-weight: 400;
}

.ReviewPhotos-infoSubtitle-pjyda {
  color: #7e9cb2;
  font-size: 11.5px;
  line-height: 1.35;
  margin: 0;
  font-weight: 400;
}

/* Responsive Tablet */

@media screen and (max-width: 1024px) and (min-width: 768px) {
  .ReviewPhotos-contentWrapper-hSjBo {
    padding: 20px 24px 15px;
  }

  .ReviewPhotos-photoGrid-AfRur {
    gap: 14px;
  }

  .ReviewPhotos-photoItemCover-V2mVZ,
  .ReviewPhotos-photoItem-PSOoS,
  .ReviewPhotos-addPhotoCard-Ubmne {
    border-radius: 18px;
  }

  .ReviewPhotos-addPhotoText-y7hiK {
    font-size: 11.5px;
  }

  .ReviewPhotos-deleteBtn-LHX4g {
    width: 30px;
    height: 30px;
  }
}

/* Responsive Mobile: 2 columnas, sin ubicaciones especiales ni sobreposición */

@media screen and (max-width: 767px) {
  .ReviewPhotos-contentWrapper-hSjBo {
    padding: 16px 16px 12px;
  }

  .ReviewPhotos-photoGrid-AfRur {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .ReviewPhotos-photoGrid-AfRur> :nth-child(6),
  .ReviewPhotos-photoGrid-AfRur> :nth-child(7),
  .ReviewPhotos-photoGrid-AfRur> :nth-child(8) {
    grid-column: auto;
    grid-row: auto;
    z-index: auto;
    border: 0;
    -webkit-box-shadow: 0 4px 14px rgba(15, 76, 129, 0.08);
            box-shadow: 0 4px 14px rgba(15, 76, 129, 0.08);
  }

  .ReviewPhotos-photoGrid-AfRur>.ReviewPhotos-addPhotoCard-Ubmne:nth-child(6),
  .ReviewPhotos-photoGrid-AfRur>.ReviewPhotos-addPhotoCard-Ubmne:nth-child(7),
  .ReviewPhotos-photoGrid-AfRur>.ReviewPhotos-addPhotoCard-Ubmne:nth-child(8) {
    border: 1.8px dashed #b3d4f5;
    -webkit-box-shadow: none;
            box-shadow: none;
  }

  .ReviewPhotos-photoItemCover-V2mVZ {
    grid-column: 1 / -1;
    grid-row: auto;
    border-radius: 14px;
    aspect-ratio: 4 / 3;
    min-height: 180px;
  }

  .ReviewPhotos-photoItem-PSOoS {
    border-radius: 14px;
  }

  .ReviewPhotos-addPhotoCard-Ubmne {
    border-radius: 14px;
  }

  .ReviewPhotos-deleteBtn-LHX4g {
    width: 26px;
    height: 26px;
    top: 8px;
    right: 8px;
  }

  .ReviewPhotos-deleteBtn-LHX4g svg {
    width: 10px;
    height: 10px;
  }

  .ReviewPhotos-coverBadge-ij99b {
    font-size: 11px;
    padding: 4px 10px;
    top: 8px;
    left: 8px;
  }

  .ReviewPhotos-infoTitle-ITgym {
    font-size: 12px;
  }

  .ReviewPhotos-infoSubtitle-pjyda {
    font-size: 10.5px;
  }
}

/* Responsive Small Mobile */

@media screen and (max-width: 480px) {
  .ReviewPhotos-photoGrid-AfRur {
    gap: 8px;
  }

  .ReviewPhotos-photoItemCover-V2mVZ {
    border-radius: 12px;
  }

  .ReviewPhotos-photoItem-PSOoS {
    border-radius: 12px;
  }

  .ReviewPhotos-addPhotoCard-Ubmne {
    border-radius: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ListPlaceStep1/ReviewPhotos.css"],"names":[],"mappings":"AAAA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;AAEA,0CAA0C;;AAC1C;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAY;EAAZ,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,sDAA8C;UAA9C,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAY;EAAZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sDAA8C;UAA9C,8CAA8C;EAC9C,8BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;;;;CAIC;;AACD;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,sDAAsD;EACtD,wDAAgD;UAAhD,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yCAAyC;EACzC,UAAU;EACV,mBAAmB;EACnB,oCAAoC;EACpC,2CAA2C;EAC3C,2BAA2B;EAC3B,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,sEAAsE;;AAEtE;;EAEE,wBAAgB;EAAhB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,oDAA4C;UAA5C,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,UAAU;EACV,UAAU;EACV,iDAAyC;UAAzC,yCAAyC;EACzC,6EAA6D;EAA7D,qEAA6D;EAA7D,6DAA6D;EAA7D,2FAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kEAA0D;EAA1D,0DAA0D;EAC1D,yBAAiB;KAAjB,sBAAiB;MAAjB,qBAAiB;UAAjB,iBAAiB;EACjB,8BAAsB;UAAtB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAc;MAAd,cAAc;EACd,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;;AACtB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,+EAA+E;;AAC/E;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;;;IAGE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,SAAS;IACT,sDAA8C;YAA9C,8CAA8C;EAChD;;EAEA;;;IAGE,4BAA4B;IAC5B,wBAAgB;YAAhB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,4BAA4B;;AAC5B;EACE;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".contentWrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 30px 35px 15px;\n  overflow-y: auto;\n}\n\n.photoGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n  width: 100%;\n}\n\n/* Foto de portada: 2 columnas x 3 filas */\n.photoItemCover {\n  grid-column: 1 / 3;\n  grid-row: 1 / 4;\n  position: relative;\n  border-radius: 22px;\n  overflow: hidden;\n  cursor: grab;\n  background-color: #f1f5f9;\n  min-height: 220px;\n  box-shadow: 0 4px 14px rgba(15, 76, 129, 0.08);\n}\n\n.photoItem {\n  position: relative;\n  border-radius: 22px;\n  overflow: hidden;\n  cursor: grab;\n  background-color: #f1f5f9;\n  aspect-ratio: 6 / 5;\n  box-shadow: 0 4px 14px rgba(15, 76, 129, 0.08);\n  box-sizing: border-box;\n}\n\n/*\n  Fila 3: tres celdas del mismo tamaño en las columnas 2, 3 y 4.\n  Las celdas son: foto 6, foto 7 (o tarjeta \"Agregar\") y la siguiente.\n  La celda de la columna 2 se sobrepone a la portada.\n*/\n.photoGrid> :nth-child(6) {\n  grid-column: 2;\n  grid-row: 3;\n  z-index: 2333;\n  border-radius: 20px 0px 20px 0px;\n  border: 9px solid var(--background-primary);\n  position: relative;\n  /* Ensure positioning context for the pseudo-element */\n  box-shadow: 0 0 0 10px var(--background-primary);\n  /* Creates an outward border effect */\n}\n\n.photoGrid> :nth-child(6)::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 10px;\n  top: -10px;\n  /* Position the tab above the container */\n  left: 30px;\n  border-radius: 20px;\n  /* Rounded top corners for the tab */\n  background-color: var(--background-primary);\n  /* Match the border color */\n  z-index: 1;\n  /* Ensure it appears above other elements */\n}\n\n.photoGrid> :nth-child(7) {\n  grid-column: 3;\n  grid-row: 3;\n}\n\n.photoGrid> :nth-child(8) {\n  grid-column: 4;\n  grid-row: 3;\n}\n\n/* Desde el hijo 9 en adelante, el grid fluye en filas de 4 columnas */\n\n.photoItemCover:active,\n.photoItem:active {\n  cursor: grabbing;\n}\n\n.photoThumb {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-color: #e2e8f0;\n}\n\n.coverBadge {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  background-color: #0b375b;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 8px;\n  z-index: 2;\n  letter-spacing: 0.1px;\n  box-shadow: 0 2px 6px rgba(11, 55, 91, 0.25);\n}\n\n.deleteBtn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 50%;\n  background-color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n  padding: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);\n  transition: transform 0.15s ease, background-color 0.15s ease;\n}\n\n.deleteBtn svg {\n  width: 13px;\n  height: 13px;\n}\n\n.deleteBtn:hover {\n  transform: scale(1.08);\n  background-color: #f8fafc;\n}\n\n.addPhotoCard {\n  position: relative;\n  width: 100%;\n  border: 1.8px dashed #b3d4f5;\n  background: #f7fbff;\n  border-radius: 22px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  aspect-ratio: 6 / 5;\n  padding: 12px 8px;\n  transition: border-color 0.2s, background 0.2s, color 0.2s;\n  user-select: none;\n  box-sizing: border-box;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.addPhotoCard:hover {\n  background: #eef6fe;\n  border-color: #2196F3;\n  color: #2196F3;\n}\n\n.addPhotoText {\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.3;\n  text-align: center;\n  pointer-events: none;\n}\n\n.addPhotoCard:hover .addPhotoText {\n  color: #2196F3;\n}\n\n.hiddenInput {\n  display: none !important;\n  position: absolute !important;\n  width: 0 !important;\n  height: 0 !important;\n  opacity: 0 !important;\n  overflow: hidden !important;\n  pointer-events: none !important;\n}\n\n.isDragging {\n  opacity: 0.4;\n}\n\n.isDragOver {\n  outline: 2px dashed #0084f8;\n  outline-offset: -2px;\n}\n\n.infoSection {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  margin-top: 24px;\n  margin-bottom: 20px;\n  padding: 0 2px;\n}\n\n.infoIconWrap {\n  flex-shrink: 0;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n}\n\n.infoTextWrap {\n  display: flex;\n  flex-direction: column;\n}\n\n.infoTitle {\n  color: #4a6d88;\n  font-size: 13.5px;\n  line-height: 1.45;\n  margin: 0 0 3px 0;\n  font-weight: 400;\n}\n\n.infoSubtitle {\n  color: #7e9cb2;\n  font-size: 11.5px;\n  line-height: 1.35;\n  margin: 0;\n  font-weight: 400;\n}\n\n/* Responsive Tablet */\n@media screen and (max-width: 1024px) and (min-width: 768px) {\n  .contentWrapper {\n    padding: 20px 24px 15px;\n  }\n\n  .photoGrid {\n    gap: 14px;\n  }\n\n  .photoItemCover,\n  .photoItem,\n  .addPhotoCard {\n    border-radius: 18px;\n  }\n\n  .addPhotoText {\n    font-size: 11.5px;\n  }\n\n  .deleteBtn {\n    width: 30px;\n    height: 30px;\n  }\n}\n\n/* Responsive Mobile: 2 columnas, sin ubicaciones especiales ni sobreposición */\n@media screen and (max-width: 767px) {\n  .contentWrapper {\n    padding: 16px 16px 12px;\n  }\n\n  .photoGrid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n\n  .photoGrid> :nth-child(6),\n  .photoGrid> :nth-child(7),\n  .photoGrid> :nth-child(8) {\n    grid-column: auto;\n    grid-row: auto;\n    z-index: auto;\n    border: 0;\n    box-shadow: 0 4px 14px rgba(15, 76, 129, 0.08);\n  }\n\n  .photoGrid>.addPhotoCard:nth-child(6),\n  .photoGrid>.addPhotoCard:nth-child(7),\n  .photoGrid>.addPhotoCard:nth-child(8) {\n    border: 1.8px dashed #b3d4f5;\n    box-shadow: none;\n  }\n\n  .photoItemCover {\n    grid-column: 1 / -1;\n    grid-row: auto;\n    border-radius: 14px;\n    aspect-ratio: 4 / 3;\n    min-height: 180px;\n  }\n\n  .photoItem {\n    border-radius: 14px;\n  }\n\n  .addPhotoCard {\n    border-radius: 14px;\n  }\n\n  .deleteBtn {\n    width: 26px;\n    height: 26px;\n    top: 8px;\n    right: 8px;\n  }\n\n  .deleteBtn svg {\n    width: 10px;\n    height: 10px;\n  }\n\n  .coverBadge {\n    font-size: 11px;\n    padding: 4px 10px;\n    top: 8px;\n    left: 8px;\n  }\n\n  .infoTitle {\n    font-size: 12px;\n  }\n\n  .infoSubtitle {\n    font-size: 10.5px;\n  }\n}\n\n/* Responsive Small Mobile */\n@media screen and (max-width: 480px) {\n  .photoGrid {\n    gap: 8px;\n  }\n\n  .photoItemCover {\n    border-radius: 12px;\n  }\n\n  .photoItem {\n    border-radius: 12px;\n  }\n\n  .addPhotoCard {\n    border-radius: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `ReviewPhotos-contentWrapper-hSjBo`,
	"photoGrid": `ReviewPhotos-photoGrid-AfRur`,
	"photoItemCover": `ReviewPhotos-photoItemCover-V2mVZ`,
	"photoItem": `ReviewPhotos-photoItem-PSOoS`,
	"photoThumb": `ReviewPhotos-photoThumb-bdan9`,
	"coverBadge": `ReviewPhotos-coverBadge-ij99b`,
	"deleteBtn": `ReviewPhotos-deleteBtn-LHX4g`,
	"addPhotoCard": `ReviewPhotos-addPhotoCard-Ubmne`,
	"addPhotoText": `ReviewPhotos-addPhotoText-y7hiK`,
	"hiddenInput": `ReviewPhotos-hiddenInput-Yczke`,
	"isDragging": `ReviewPhotos-isDragging-p4Lvq`,
	"isDragOver": `ReviewPhotos-isDragOver-gjtDO`,
	"infoSection": `ReviewPhotos-infoSection-TNKJK`,
	"infoIconWrap": `ReviewPhotos-infoIconWrap-pPMuv`,
	"infoTextWrap": `ReviewPhotos-infoTextWrap-siDBY`,
	"infoTitle": `ReviewPhotos-infoTitle-ITgym`,
	"infoSubtitle": `ReviewPhotos-infoSubtitle-pjyda`
};
module.exports = ___CSS_LOADER_EXPORT___;
